import React, { Component, Fragment } from 'react';
import { Button } from 'semantic-ui-react';
import { withRouter } from "react-router-dom";
import SelectReasonModal from './modals/SelectReasonModal';
import { withApollo, compose } from 'react-apollo';
import { CreateSettlementMutation } from '../mutations/CreateSettlementMutation';
import RedirectWithFilters from './RedirectWithFilters';
import ConfirmationModal from './modals/ConfirmationModal';
import mapCPTs from '../utils/mapCPTs';
import mapConnection from '../utils/connectionMapper';

const options = [
  { key: 0, text: 'waiver', value: 'waiver' },
  { key: 1, text: 'no waiver', value: 'noWaiver' }
]

class Settled extends Component {
  state = { selectReasonModalOpen: false, confirmWaverGenerationModal: false }

  sendSettlementMutation = (forceGenerateWaivers) => {
    this.props.client.mutate({
      mutation: CreateSettlementMutation,
      variables: {
        input: {
          claimId: this.props.claimId,
          waiver: this.state.waiver,
          taskId: this.props.taskId,
          forceGenerateWaivers: forceGenerateWaivers
        }
      }
    }).then(() => {
      this.setState({ redirect: true })
    }).catch((error) => {
      console.error(error)
    })
  }

  handleClose = (reason, ) => {
    if (!reason) return
    const waiver = reason === 'waiver'

    this.setState({ selectReasonModalOpen: false, waiver: waiver }, () => {
      if (!waiver) {
        this.sendSettlementMutation(false)
        return
      }
      const { some, all } = this.anyPassengerHasWaiver()
      if (some)
        this.sendSettlementMutation(!all)
      else this.setState({ confirmWaverGenerationModal: true })
    })
  }

  handleConfirmation = (test) => {
    this.setState({ confirmWaverGenerationModal: false, selectReasonModalOpen: false })
    if (test) {
      this.sendSettlementMutation(true)
    }
  }

  toggleModal = (state) => {
    if(state) this.props.refetch()
    this.setState({ selectReasonModalOpen: state })
  }

  anyPassengerHasWaiver = () => {
    if (!this.props.claim.claimsPassengerTicketConnection) return false
    const { documents, claimsPassengerTickets } = mapCPTs(this.props.claim)
    const cpt = claimsPassengerTickets.map(c => ({ id: c.id, docs: mapConnection(c.documentsConnection) }))
    return {
      some: documents.some(doc => doc.type === 'Documents::Waiver'),
      all: cpt.every(c =>
        c.docs.some(d =>
          d.type === 'Documents::Waiver'
        ))
    }
  }

  render = () => {
    if (this.state.redirect) {
      const to = this.props.location.state ? this.props.location.state.previousPath : ''
      return <RedirectWithFilters to={to} />;
    }
    return (
      <Fragment>
        <SelectReasonModal
          operation='settled'
          question='Attach waiver?'
          options={options}
          hideModal={() => this.toggleModal(false)}
          handleClose={this.handleClose}
          isDescriptionVisible={false}
          open={this.state.selectReasonModalOpen}
        />
        <ConfirmationModal
          onConfirmation={this.handleConfirmation}
          isOpen={this.state.confirmWaverGenerationModal}
          question='None of the passengers have waiver document, do you want to generate and send waiver documents for all passengers'
        />
        <Button floated="right" primary onClick={() => this.toggleModal(true)}>Settled</Button>
      </Fragment>
    )
  }
}

export default compose(
  withApollo,
  withRouter
)(Settled);


// WEBPACK FOOTER //
// ./src/component/Settled.js